import { render, staticRenderFns } from "./SpecimentFormPage.vue?vue&type=template&id=2780c444&scoped=true&"
import script from "./SpecimentFormPage.vue?vue&type=script&lang=js&"
export * from "./SpecimentFormPage.vue?vue&type=script&lang=js&"
import style0 from "./SpecimentFormPage.vue?vue&type=style&index=0&id=2780c444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2780c444",
  null
  
)

export default component.exports